/**
 * Created by Ning Jiang on 3/31/2020.
 */

import {GuiDefaults} from "@nolimitcity/slot-launcher/bin/gui/default/GuiDefaults";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";

export class DeadwoodIntroSlideShowPage extends SlideShowPage {

    private titleStyle:PIXI.TextStyle = new PIXI.TextStyle({
        fill : GuiDefaults.INTRO_PAGE_TEXT.fill,
        fontFamily : GuiDefaults.INTRO_PAGE_TEXT.fontFamily,
        fontSize : <number>GuiDefaults.INTRO_PAGE_TEXT.fontSize + 10,
        fontStyle : GuiDefaults.INTRO_PAGE_TEXT.fontStyle,
        fontWeight : GuiDefaults.INTRO_PAGE_TEXT.fontWeight,
        wordWrap : GuiDefaults.INTRO_PAGE_TEXT.wordWrap,
        wordWrapWidth : GuiDefaults.INTRO_PAGE_TEXT.wordWrapWidth
    });

    constructor(textures:PIXI.Texture[], imageScales:number[]) {
        super(undefined, undefined);

        if(textures.length === 1) {
            const image = new PIXI.Sprite(textures[0]);
            image.anchor.set(0.5);
            image.scale.set(imageScales[0]);
            this.addChild(image);
        } else {
            const imageLeft = new PIXI.Sprite(textures[0]);
            imageLeft.anchor.x = 1;
            imageLeft.anchor.y = 0.5;
            imageLeft.position.x = -55;
            imageLeft.scale.set(imageScales[0]);
            this.addChild(imageLeft);

            const imageRight = new PIXI.Sprite(textures[1]);
            imageRight.anchor.x = 0;
            imageRight.anchor.y = 0.5;
            imageRight.position.x = -45;
            imageRight.scale.set(imageScales[1]);
            this.addChild(imageRight);
        }
    }
}